import PromotionPoints from "components/Home/PromotionPoints";

const SubscriptionsPromotionDetails = () => {
  return (
    <>
      <p className={`text-navyBlue font-poppins`}>
        Lock in customer commitment upfront, drive prepaid demand into your
        store, and generate recurring revenue
      </p>

      <PromotionPoints
        heading={"How it works:"}
        points={[
          "Shoppers can subscribe to a plan that gives them access to specific items or services for a set monthly price.",
          "Each subscription tier defines how many items they receive, how often they can redeem them, and on which days they're valid.",
          "For example, a shopper might pay $10/month for 10 coffees, limited to 1 per day, Monday–Thursday only.",
          "Subscriptions renew automatically every month unless canceled by the shopper.",
        ]}
      />

      <PromotionPoints
        heading={"Perks:"}
        points={[
          'Highlighted under the prominent "Subscriptions" filter on Discovery tab',
          "Announcement in home screen activity feed",
          "Shared with customers who have previously made a purchase with you",
        ]}
      />
    </>
  );
};

export default SubscriptionsPromotionDetails;
